<template>
  <a-popover :title="`Canales de ${channel}`">
    <template slot="content">
      <ul class="popover__list">
        <li
          v-for="(title, index) in listTitleWithLimit"
          :key="`title-${index}`"
        >
          {{ title }}
        </li>
      </ul>
      <div
        class="display-flex justify-content--end"
        v-if="listTitles.length > 10 && actionEnabled"
      >
        <span class="popover__redirect" @click="$emit('handleModal')">
          Ver mas canales</span
        >
      </div>
    </template>
    <channel-badge :channel="channel" :count="listTitles.length" />
  </a-popover>
</template>

<script>
import ChannelBadge from '@/app/shared/components/molecules/ChannelBadge'

export default {
  name: 'PopoverChannel',
  props: {
    channel: {
      type: String,
      required: true,
    },
    listTitles: {
      type: Array,
      required: true,
    },
    actionEnabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ChannelBadge,
  },
  computed: {
    /**
     * Lista de titulos con un limite
     * @return { Array}
     */
    listTitleWithLimit() {
      if (this.listTitles.length > 10 && this.actionEnabled) {
        return this.listTitles.slice(0, 10)
      }
      return this.listTitles
    },
  },
}
</script>

<style lang="sass" scoped>
.popover__list
  padding-left: 20px
  margin-bottom: 0px

.popover__redirect
  color: $blue_light_900
  font-weight: 500
  cursor: pointer
</style>
